export const objectToUrlParams = (obj: object) => {
    const params = new URLSearchParams();

    for (const [k, v] of Object.entries(obj)) {
        if (Array.isArray(v)) {
            v.forEach((e) => params.append(k, e));
        } else if (v) {
            params.set(k, v);
        }
    }

    return params;
};
